/** @file One PNG chunk: length, type, data and the CRC-32 of type + data. */
import { crc32 } from './_internal/crc32';

/** Encodes `type` (four ASCII letters) and `data` as a chunk: u32 length, type, data, u32 CRC of type + data. */
export function pngChunk(type: string, data: Uint8Array): Uint8Array {
  const out = new Uint8Array(12 + data.length);
  const view = new DataView(out.buffer);
  view.setUint32(0, data.length);
  for (let i = 0; i < 4; i++) out[4 + i] = type.charCodeAt(i);
  out.set(data, 8);
  view.setUint32(8 + data.length, crc32(out, 4, 8 + data.length));
  return out;
}
